import { SxProps, Theme } from "@mui/material";
import { CSSProperties } from "react";

export const businessCheckout = {
  // Header
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    marginTop: "30px",
    marginBottom: "10px"
  },
  image: { width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' } as CSSProperties,
  firstNameText: {
    fontSize: 24,
    fontWeight: "700",
    textAlign: "center",
    color: "#000",
  },
  listHeadline: {
    fontSize: "15px",
    fontWeight: "400",
    textAlign: "center",
    lineHeight: "20px",
  },

  // Toggle
  toggleContainer: {
    marginY: "20px",
    display: "flex",
    justifyContent: "center",
    gap: "20px",
  },

  activeText: (theme: Theme): SxProps<Theme> => ({
    fontSize: "22px",
    fontWeight: "600",
    color: "#000",
    cursor: "pointer",
    borderBottom: "3px solid #328734",
    [theme.breakpoints.down(400)]: {
      fontSize: "18px"
    }
  }),

  inAciveText: (theme: Theme): SxProps<Theme> => ({
    fontSize: "22px",
    fontWeight: "600",
    color: "#8D8D8D",
    cursor: "pointer",
    [theme.breakpoints.down(400)]: {
      fontSize: "18px"
    }
  }),

  customDay: (isToday: boolean): SxProps<Theme> => ({
    ...(isToday && {
      color: "#000",
      fontWeight: "bold",
      border: "none !important",
    }),
  }),

  // calender
  calenderContainer: {
    display: "flex",
    justifyContent: "center",
  },
  dateBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 20px",
    border: "1px solid #8D8D8D",
    borderRadius: "15px",
    cursor: "pointer",
    backgroundColor: "#fff",
    width: "fit-content",
  },
  dateText: { fontSize: "17px", fontWeight: "400", color: "#595959" },
  // business card
  businessCard: (theme: Theme): SxProps<Theme> => ({
    borderRadius: "10px",
    marginBottom: "20px",
    fontFamily: theme.typography.fontFamily,
    border: "1px solid #8D8D8D",
    boxShadow: "2px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    width: "380px",
    [theme.breakpoints.down("sm")]: {
      width: "350px",
    },
  }),
  businessImageBox: {
    borderRadius: "8px",
  },
  businessImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover" as const,
    display: "block",
    borderRadius: "8px 8px 0px 0px",
  },
  cardDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingY: "10px",
    paddingX: "15px",
  },
  businessTitle: {
    color: "#000",
    fontSize: "24px",
    fontWeight: "700",
    paddingTop: "7px",
    borderBottom: "1px solid #595959",
  },

  businessAddress: {
    color: "#000",
    fontSize: "13px",
    fontWeight: "400",
  },

  businessHeadline: {
    color: "#595959",
    fontSize: "15px",
    fontWeight: "400",
    paddingY: "10px",
  },
  businessAvailability: {
    color: "#000",
    fontSize: "17px",
    fontWeight: "600",
    borderBottom: "1px solid #328734",
    cursor: "pointer",
  },
};
